<template>
  <div>
    <h2>{{ $t('W2P_UPLOAD_MATERIAL_PAGE_TITLE') }}</h2>
    <p class="small paragraph">
      {{ $t('W2P_UPLOAD_MATERIAL_SELECTION_DESCRIPTION') }}
    </p>

    <div class="cards-container">
      <div class="card-image">
        <img src="@/assets/images/upload-cloud.svg" alt="Upload file" />
      </div>
      <p class="card-label">
        {{ $t('W2P_UPLOAD_MATERIAL_SELECTION_UPLOAD') }}
      </p>
    </div>
    <div class="cards-container">
      <input
        id="material-upload"
        type="radio"
        name="option"
        v-model="picked"
        value="/letter/upload/upload-letter"
        aria-label="Upload"
      />
      <label for="material-upload" tabindex="0" @keydown.enter="clickedLabel">
        <div class="card-image">
          <img src="@/assets/images/upload-cloud.svg" alt="Upload file" />
        </div>
        <p class="card-label">
          {{ $t('W2P_UPLOAD_MATERIAL_SELECTION_UPLOAD') }}
        </p>
      </label>
      <input
        id="material-test-file"
        type="radio"
        name="option"
        v-model="picked"
        value="/letter/address"
        aria-label="Test file"
      />
      <label class="disabled">
        <div class="card-image">
          <img src="@/assets/images/try-test-file.svg" alt="Try a test file" />
        </div>
        <p class="card-label">
          {{ $t('W2P_UPLOAD_MATERIAL_SELECTION_TEST_FILE') }}
        </p>
      </label>
    </div>

    <div class="button-container">
      <pn-button-container secondary size="medium">
        <button @click="$router.push({ name: 'upload' })">
          {{ $t('W2P_LETTER_BACK') }}
        </button>
      </pn-button-container>

      <pn-button-container size="medium">
        <button :disabled="isNotPicked" @click="next" class="next">
          {{ $t('W2P_LETTER_NEXT') }}
        </button>
      </pn-button-container>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  data: () => ({
    picked: ''
  }),
  beforeMount() {
    this.picked = this.$store.state.letter.upload.selectedUploadOption
  },
  mounted() {
    sessionStorage.removeItem('orderPlaced')
  },
  computed: {
    isNotPicked() {
      return !this.picked
    }
  },
  methods: {
    ...mapMutations('letter/upload', ['SET_MATERIAL']),
    clickedLabel(e) {
      this.picked = document.getElementById(e.srcElement.htmlFor).value
    },
    next() {
      this.SET_MATERIAL({
        key: 'selectedUploadOption',
        value: this.picked
      })
      this.$router.push(this.picked)
    }
  }
}
</script>

<style lang="scss" scoped>
.cards-container {
  display: flex;
  margin-top: 2em;
  width: 100%;

  label {
    padding: 8% 7%;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 0.1rem solid $gray400;
    cursor: pointer;
    margin-right: 0.5em;

    &:last-child {
      margin-right: 0;
      margin-left: 0.5em;
    }

    &:hover {
      background: $blue50;
    }

    .card-image {
      img {
        width: 100%;
      }
    }

    .card-label {
      margin-top: 1em;
      color: $black;
      font-size: 1em;
    }

    &.disabled {
      border-color: $gray200;
      background-color: $gray50;

      .card-image img {
        opacity: 0.2;
      }

      .card-label {
        color: $gray200;
      }

      &:hover {
        cursor: default;
      }
    }
  }

  input[type='radio'] {
    display: none;
    position: absolute;
  }

  input[type='radio']:checked + label {
    background: $blue50;
    border: 0.1rem solid $blue700;
    border-bottom-width: 0.7rem;
  }

  input[type='radio']:focus + label {
    outline: rgba(77, 97, 171, 0.5) auto 0.3rem;
  }
}

.paragraph {
  margin-top: 0.5em;
  color: $gray700;
}
</style>
